import Icon from "../../lib/icon";
import isEmpty from "../../utils/isEmpty";
import "./BadgeBonus.scss";

export default function BadgeBonus({ size = "medium", value = 0 }) {
  function getSizes() {
    switch (size) {
      case "small":
        return {
          h: 16,
          coin: 12,
          text: 9,
          line: 12,
          padding: "py-0.5 px-1 pl-0.5",
          gap: "gap-0.5",
          textWidth: 24,
        };
      case "medium":
        return {
          h: 20,
          coin: 14,
          text: 12,
          line: 16,
          padding: "medium",
          textWidth: 32,
        };
      case "large":
        return {
          h: 24,
          coin: 16,
          text: 14,
          line: 20,
          padding: "py-0.5 px-2 pl-1",
          gap: "gap-1",
          textWidth: 36,
        };
      default:
        return {
          h: 20,
          coin: 14,
          text: 12,
          line: 16,
          padding: "py-0.5 px-2 pl-1",
          gap: "gap-1",
          textWidth: 32,
        };
    }
  }

  function getBadgeValue() {
    if (!isEmpty(value)) return value;
    return 0;
  }

  const s = getSizes();
  const v = getBadgeValue();

  return (
    <div
      className={`flex items-center bg-gradient-to-r from-[#D72D4F] via-[#E61E46] to-[#801C30] rounded-full ${s.padding} ${s.gap} badge-bonus`}
      style={{ height: s.h, width: "max-content" }}
    >
      <div
        className="badge-bonus__icon"
        style={{ width: s.coin, height: s.coin }}
      >
        <Icon name="coin" width={s.coin} height={s.coin} color="#fff" />
      </div>

      <span
        className="text-white font-inter-18-semi-bold text-center badge-bonus__value"
        style={{
          fontSize: s.text,
        }}
      >
        {v}
      </span>
    </div>
  );
}
